/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var faqAccordion = {
  init: function () {
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.on('click activate', function () {
      if (flg) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(function () {
        flg = 0;
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown', function (event) {
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  }
}
faqAccordion.init();
var productTabs = function ($tabGroup) {
  let cache = {
    $tab: $tabGroup.find(".js-tab"),
    $tabContent: $tabGroup.find("[data-tab-content]"),
    $nutritionAnchor: $tabGroup.find(".nutrition-anchor")
  };
  const handleTabClick = function (e) {
    let $this = $(this),
      tabNumber = $this.data("tab");
    cache.$tab.not($this).removeClass("active"), $this.addClass("active"), cache.$tabContent.removeClass("active"), cache.$tabContent.closest("[data-tab-content='" + tabNumber + "']").addClass("active")
  };
  return cache.$nutritionAnchor.on("click", (function () {
    $('[data-tab="2"]').click()
  })), void cache.$tab.on("click", handleTabClick)
};
const productTabInit = function () {
  let settings_tabGroup = ".js-tab-group";
  return hash = $(location).attr("hash").replace("#", ""), $(settings_tabGroup).each((function (index, tabGroup) {
    productTabs($(tabGroup))
  })), void(hash && $('[id="' + hash + '"]').click());
  var hash
}();
$(function () {
  $(".js-social-slider").slick({
    slidesToShow: 1,
    arrows: !1,
    centerMode: !0,
    mobileFirst: !0,
    responsive: [{
      breakpoint: 560,
      settings: {
        slidesToShow: 3,
        centerMode: !1
      }
    }, {
      breakpoint: 1023,
      settings: {
        slidesToShow: 4,
        centerMode: !1
      }
    }]
  });
  $('.qmr-close-drawer').click(function(){
    $('#sidebar-facts').attr('aria-hidden', 'true');
  });
  $('.trigger-facts').click(function(){
    $('#sidebar-facts').attr('aria-hidden', 'false');
  });
});

$('.product_tabs #tabs-nav li:first-child').addClass('active');
$('.product_tabs .tab-content').hide();
$('.product_tabs .tab-content:first').show();
$('.product_tabs #tabs-nav li').click(function(){
  $('.product_tabs #tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.product_tabs .tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
